import React, { useEffect } from 'react';
import FilterDropdown from '../../FilterDropdown/FilterDropdown';
import FilterButton from '../../FilterButton/FilterButton';
import useFilterState from '../../../hooks/useFilterState';
import useFilterItemsWithAmount from '../../../hooks/useFilterItemsWithAmount';
import { filtersData } from '../../../constants/filtersData';
import { filterNames } from '../../../constants/filterNames';
import useCities from '../../../queries/useCities';
import FilterContainer from '../../FilterContainer/FilterContainer';
import SelectedOption from '../../SelectedOption/SelectedOption';
import { useFilterOptionsShorter } from '../../../hooks/useFilterOptionsShorter';
import { HiddenSelectedOptions } from '../../HiddenSelectedOptions/HiddenSelectedOptions';

const filter = filtersData[filterNames.cities];

const CitiesFilter = ({ disabled = false }) => {
  const [filterState, setFilterState] = useFilterState(filter);

  const { data, isFetching } = useCities({ options: { staleTime: Infinity } });

  const { items, itemsMap } = useFilterItemsWithAmount({
    data,
    requestKey: 'cityId',
  });

  const handleItemRemove = (id) => {
    const newState = filterState.filter((itemId) => itemId !== id);

    setFilterState(newState);
  };

  const hasFilter = filterState.length > 0;

  const allSelected = hasFilter && itemsMap.size === filterState.length;

  const filteredItems = items.filter((item) => filterState.includes(item.id));
  const { visibleItems, hiddenItems } = useFilterOptionsShorter(filteredItems);

  return (
    <FilterContainer>
      <FilterDropdown
        disabled={isFetching || disabled}
        filter={filter}
        items={items}
        getItemContent={(item) => item.name}
        getSearchContent={(item) => item.name}
        renderButton={({ visible }) => (
          <FilterButton
            text="Город"
            opened={visible}
            selected={hasFilter}
          />
        )}
      />
      {allSelected ? (
        <SelectedOption
          text="Все"
          onRemove={() => setFilterState([])}
        />
      ) : (
        <>
          {visibleItems.map((item) => (
            <SelectedOption
              key={item.id}
              text={item.name}
              value={item.id}
              onRemove={handleItemRemove}
            />
          ))}
          {Array.isArray(hiddenItems) && !!hiddenItems.length && (
            <HiddenSelectedOptions
              hiddenItems={hiddenItems}
              handleItemRemove={handleItemRemove}
            />
          )}
        </>
      )}
    </FilterContainer>
  );
};

export default CitiesFilter;
